/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Medialibrarydeleteconfirmtitle4Inputs */

const en_medialibrarydeleteconfirmtitle4 = /** @type {(inputs: Medialibrarydeleteconfirmtitle4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete “${i?.title}”?`)
};

const de_medialibrarydeleteconfirmtitle4 = /** @type {(inputs: Medialibrarydeleteconfirmtitle4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.title}“ löschen?`)
};

/**
* | output |
* | --- |
* | "Delete “{title}”?" |
*
* @param {Medialibrarydeleteconfirmtitle4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarydeleteconfirmtitle4 = /** @type {((inputs: Medialibrarydeleteconfirmtitle4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarydeleteconfirmtitle4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarydeleteconfirmtitle4(inputs)
	return de_medialibrarydeleteconfirmtitle4(inputs)
});
export { medialibrarydeleteconfirmtitle4 as "mediaLibraryDeleteConfirmTitle" }